export { default } from './HoldsSidebarLink';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsSidebarLink/index.js